<template>
  <h1>Push here</h1>
</template>
<script>
import axios from 'axios';
export default {
  name: "Push",
  data() {
    return {};
  },
  methods: {},
  mounted() { },
  created() {

  }
};
</script>